import Navbar from "../components/navbar";
import GetStartedForm from '../components/GetStartPage/get-started-form';
import GetStartedInfo from '../components/GetStartPage/get-started-info';

const GetStart = () => {
    return (
      <>
        <Navbar classNav="nav-dark-bg"/>
        <div className="get-start">
          <div className="container d-flex align-items-center">
            <GetStartedForm/>
            <GetStartedInfo/>
          
          </div>
        </div>
      </>
    );
  };
  
  export default GetStart;